// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../ui/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../ui/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../ui/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/bricolage-grotesque.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/work-sans.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/spline-sans-mono.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Self-hosted variable fonts (latin subset) — the Harbor Ledger type system.
   Bricolage Grotesque: display · Work Sans: body · Spline Sans Mono: data.
   Files are Google Fonts variable woff2s; one file covers each family's
   full weight range below. */

@font-face {
  font-family: 'Bricolage Grotesque';
  font-style: normal;
  font-weight: 500 700;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
}

@font-face {
  font-family: 'Work Sans';
  font-style: normal;
  font-weight: 400 600;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2');
}

@font-face {
  font-family: 'Spline Sans Mono';
  font-style: normal;
  font-weight: 400 500;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2');
}
`, "",{"version":3,"sources":["webpack://./../shared/theme/fonts.css"],"names":[],"mappings":"AAAA;;;6BAG6B;;AAE7B;EACE,kCAAkC;EAClC,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,4DAA6D;AAC/D;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,4DAAmD;AACrD;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,4DAA0D;AAC5D","sourcesContent":["/* Self-hosted variable fonts (latin subset) — the Harbor Ledger type system.\n   Bricolage Grotesque: display · Work Sans: body · Spline Sans Mono: data.\n   Files are Google Fonts variable woff2s; one file covers each family's\n   full weight range below. */\n\n@font-face {\n  font-family: 'Bricolage Grotesque';\n  font-style: normal;\n  font-weight: 500 700;\n  font-display: swap;\n  src: url('./fonts/bricolage-grotesque.woff2') format('woff2');\n}\n\n@font-face {\n  font-family: 'Work Sans';\n  font-style: normal;\n  font-weight: 400 600;\n  font-display: swap;\n  src: url('./fonts/work-sans.woff2') format('woff2');\n}\n\n@font-face {\n  font-family: 'Spline Sans Mono';\n  font-style: normal;\n  font-weight: 400 500;\n  font-display: swap;\n  src: url('./fonts/spline-sans-mono.woff2') format('woff2');\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
